/**
 * Chailease.AccountingCommon.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AccountSearchResponse } from '../model/accountSearchResponse';
import { BankAccountSearchResponse } from '../model/bankAccountSearchResponse';
import { BankBranchSearchResponse } from '../model/bankBranchSearchResponse';
import { GroundAccountListBody } from '../model/groundAccountListBody';
import { GroundAccountListBody1 } from '../model/groundAccountListBody1';
import { GroundAccountListBody2 } from '../model/groundAccountListBody2';
import { GroundBankAccountBody } from '../model/groundBankAccountBody';
import { GroundBankAccountBody1 } from '../model/groundBankAccountBody1';
import { GroundBankAccountBody2 } from '../model/groundBankAccountBody2';
import { GroundBankBranchBody } from '../model/groundBankBranchBody';
import { GroundBankBranchBody1 } from '../model/groundBankBranchBody1';
import { GroundBankBranchBody2 } from '../model/groundBankBranchBody2';
import { GroundShareDepartmentBody } from '../model/groundShareDepartmentBody';
import { GroundShareDepartmentBody1 } from '../model/groundShareDepartmentBody1';
import { GroundShareDepartmentBody2 } from '../model/groundShareDepartmentBody2';
import { ShareDepartmentSearchResponse } from '../model/shareDepartmentSearchResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class GroundService {

    protected basePath = 'http://dev-apigw.chailease.com.my/dev-backdoor/accounting/common';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [Public] 查詢會計科目
     * 
     * @param body 查詢條件
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public groundAccountListPost(body?: GroundAccountListBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<AccountSearchResponse>;
    public groundAccountListPost(body?: GroundAccountListBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AccountSearchResponse>>;
    public groundAccountListPost(body?: GroundAccountListBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AccountSearchResponse>>;
    public groundAccountListPost(body?: GroundAccountListBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AccountSearchResponse>('post',`${this.basePath}/Ground/AccountList`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢銀行存放地
     * 
     * @param body 查詢條件
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public groundBankAccountPost(body?: GroundBankAccountBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<BankAccountSearchResponse>;
    public groundBankAccountPost(body?: GroundBankAccountBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BankAccountSearchResponse>>;
    public groundBankAccountPost(body?: GroundBankAccountBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BankAccountSearchResponse>>;
    public groundBankAccountPost(body?: GroundBankAccountBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BankAccountSearchResponse>('post',`${this.basePath}/Ground/BankAccount`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢金資中心
     * 
     * @param body 查詢條件
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public groundBankBranchPost(body?: GroundBankBranchBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<BankBranchSearchResponse>;
    public groundBankBranchPost(body?: GroundBankBranchBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BankBranchSearchResponse>>;
    public groundBankBranchPost(body?: GroundBankBranchBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BankBranchSearchResponse>>;
    public groundBankBranchPost(body?: GroundBankBranchBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BankBranchSearchResponse>('post',`${this.basePath}/Ground/BankBranch`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 查詢費用分攤部門
     * 
     * @param body 查詢條件
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public groundShareDepartmentPost(body?: GroundShareDepartmentBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<ShareDepartmentSearchResponse>;
    public groundShareDepartmentPost(body?: GroundShareDepartmentBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ShareDepartmentSearchResponse>>;
    public groundShareDepartmentPost(body?: GroundShareDepartmentBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ShareDepartmentSearchResponse>>;
    public groundShareDepartmentPost(body?: GroundShareDepartmentBody, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ShareDepartmentSearchResponse>('post',`${this.basePath}/Ground/ShareDepartment`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
